import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton } from "@fluentui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ModalSubmitText, ModalText, ModalTitle, ModalType } from "../common/commonConstants";
import { closeModal, deleteMenu, deleteMenuItem, deleteStation, publishMenu } from "../reducers/diningReducer";
import { currentModalSelector } from "../selectors/diningSelector";
import withAppInsights from "./AppInsights/AppInsights";

export const DialogBox = () => {
  // modalContent's message state texts are found in commonConstants.ts
  const modalContent = useSelector(currentModalSelector);
  const dispatch = useDispatch();
  let submitButtonText;
  let submitFunction: () => void;
  let footer;

  // Actions for various modal submit buttons.

  const confirmStationDelete = () => {
    dispatch(closeModal());
    dispatch(deleteStation());
  };

  const confirmMenuItemDelete = () => {
    dispatch(closeModal());
    dispatch(deleteMenuItem());
  };

  const confirmPublishMenu = () => {
    dispatch(closeModal());
    dispatch(publishMenu());
  };

  const confirmDeleteMenu = () => {
    dispatch(closeModal());
    dispatch(deleteMenu());
  };

  const dismissModal = () => {
    dispatch(closeModal());
  };

  switch (modalContent) {
    case ModalType.CONFIRM_DELETE_STATION:
      submitButtonText = ModalSubmitText[modalContent];
      submitFunction = confirmStationDelete;
      footer = true;
      break;
    case ModalType.CONFIRM_MENU_ITEM_DELETE:
      submitButtonText = ModalSubmitText[modalContent];
      submitFunction = confirmMenuItemDelete;
      footer = true;
      break;
    case ModalType.CONFIRM_PUBLISH_MENU:
      submitButtonText = ModalSubmitText[modalContent];
      submitFunction = confirmPublishMenu;
      footer = true;
      break;
    case ModalType.CONFIRM_DELETE_MENU:
      submitButtonText = ModalSubmitText[modalContent];
      submitFunction = confirmDeleteMenu;
      footer = true;
      break;
    default:
      submitFunction = () => {
        return;
      };
      footer = false;
  }

  const content = {
    type: DialogType.close,
    title: modalContent ? ModalTitle[modalContent] : "",
    showCloseButton: true,
    closeButtonAriaLabel: "Close",
    subText: modalContent ? ModalText[modalContent] : "",
  };

  return (
    // Dialog and DialogFooter's typings are claiming that it can't
    // have child components. This is wrong, and this works just fine.
    // Ignoring the alerts.
    // @ts-ignore
    <Dialog hidden={!modalContent} onDismiss={dismissModal} dialogContentProps={content}>
      {footer && (
        // @ts-ignore
        <DialogFooter>
          <PrimaryButton onClick={submitFunction} text={submitButtonText} />
          <DefaultButton onClick={dismissModal} text="Cancel" />
        </DialogFooter>
      )}
    </Dialog>
  );
};

export default withAppInsights(DialogBox);
